import request from '@/utils/request'
const getPaymentsUrl = (params) => {
  return request({
    url: '/shop/payments/url',
    data: params,
    method: 'post'
  })
}

const getChannels = (id) => {
  return request({
    url: `/shop/orders/${id}/pay-channels`,
    method: 'get'
  })
}

const getfreight = (params) => {
  return request({
    url: `/shop/transport/price`,
    data: params,
    method: 'post'
  })
}

export {
  getPaymentsUrl, // 获取支付地址
  getChannels, // 获取支付通道
  getfreight // 获取运费信息
}
